import { render, staticRenderFns } from "./TypeButton.vue?vue&type=template&id=540fdbfe&scoped=true&"
import script from "./TypeButton.vue?vue&type=script&lang=js&"
export * from "./TypeButton.vue?vue&type=script&lang=js&"
import style0 from "./TypeButton.vue?vue&type=style&index=0&id=540fdbfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540fdbfe",
  null
  
)

export default component.exports